import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
      box-sizing: border-box;
  }

  #app {
      background-color: #FFFFFF;
      padding-bottom: 15px;
  }
`;
